/**
  * Because some of the old JS-Files aren't needed anymore I inserted other code altough the name stayed the same!
  *
  * Other used JS-Files:
  *   lightbox.js                        myMetadata-Box, browseViaTopic and export functionallity
  *   jquery.dynatree.js                 jquery.tableSorter.js
  *   jquery-roundabout.js               jquery.doubleScroll.js
  *   jquery.roundabout-shapes.min.js    jquery.base64.js
  */

var lastClickTime = 0;

function fadeIn() {
  return new Promise(function (resolve) {
    $('#content-anker').css('opacity', '0.3');
    $('#content-anker').css('transition', 'opacity 0.5s');
    $(".se-pre-con").fadeIn("fast", resolve);
  });
}

function fadeOut() {
  return new Promise(function (resolve) {
    $(".se-pre-con").fadeOut("slow", resolve);
    $('#content-anker').css('opacity', '1');
  });
}

$(document).on("click", async function (event) {
  if (event.target.type === "checkbox") {
    await fadeIn();
    var currentTime = new Date().getTime();

    if (currentTime - lastClickTime < 500) {
      // console.log("Der letzte Klick erfolgte innerhalb von 1 Sekunde.");
    } else {
      setTimeout(async function () {
        await fadeOut();
      }, 200);
    }
    lastClickTime = currentTime;
  }
});

/* MISSY JavaScript: General */
var doubleScrollElement;

$(window).on('load', function () {
  if (!window.location.origin) {
    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  }

  // Accordion (Menuestruktur)
  $(".gs_accordion-nest").accordion({ collapsible: true, heightStyle: "content", active: false });

  try {
    var activeId = $('.gs_active').closest('.gs_accordion-nest')[0].id;
    if (activeId == 0) {
      var x = $('.gs_active').closest('.gs_accordion-nest')[0];
      var i = x.getElementsByTagName("span");
      activeId = i[0].getAttribute("aria-controls");
      $("#" + activeId).parent().accordion('option', 'active', 0);
    }
    else {
      $("#" + activeId).accordion('option', 'active', 0);
    }
  }
  catch (err) {
    //console.log(err);
  }

  // Accordion (Pageinhalt)
  $(".m_accordion-nest").accordion({
    collapsible: true,
    heightStyle: "content",
    active: false,
    animate: false,
    beforeActivate: function (event, ui) {
      // The accordion believes a panel is being opened
      if (ui.newHeader[0]) {
        var currHeader = ui.newHeader;
        var currContent = currHeader.next('.ui-accordion-content');
        // The accordion believes a panel is being closed
      } else {
        var currHeader = ui.oldHeader;
        var currContent = currHeader.next('.ui-accordion-content');
      }
      // Since we've changed the default behavior, this detects the actual status
      var isPanelSelected = currHeader.attr('aria-selected') == 'true';

      // Toggle the panel's header
      currHeader.toggleClass('ui-corner-all', isPanelSelected).toggleClass('ui-accordion-header-active ui-state-active ui-corner-top', !isPanelSelected).attr('aria-selected', ((!isPanelSelected).toString()));

      // Toggle the panel's icon
      currHeader.children('.ui-icon').toggleClass('ui-icon-triangle-1-e', isPanelSelected).toggleClass('ui-icon-triangle-1-s', !isPanelSelected);

      // Toggle the panel's content
      currContent.toggleClass('ui-accordion-content-active', !isPanelSelected)
      if (isPanelSelected) { currContent.slideUp(); } else { currContent.slideDown(); }

      return false; // Cancels the default action
    }
  });

  if (getParam('variableIds') && getParam('variableIds').length > 0) {
    var comparatorUrl = "missy/editor/frontend/compare?variableIds=" + encodeURIComponent(getParam('variableIds'));
    getCompareElementViaAjax(comparatorUrl, "#Results");
  }

  /*
   * Replace all SVG images with inline SVG
   */
  jQuery('img.svg').each(function () {
    var $img = jQuery(this);
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function (data) {
      // Get the SVG tag, ignore the rest
      var $svg = jQuery(data).find('svg');

      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Replace image with new SVG
      $img.replaceWith($svg);
    }, 'xml');
  });

  var hash = window.location.hash;
  expandedElements = $('.expandable[src$="expand_blue.png"]').length;

  jumpBrand(hash);
  tabConfig();
  countryTabConfig();
  adjustHeightOfHeadcol();

  doubleScrollElement = $('.M_scrollableOuter:visible').doubleScroll({ resetOnWindowResize: true, onlyIfScroll: false });

  $('.missyTableSorter').tablesorter({
    sortInitialOrder: 'desc',
    /* sortList: [[1]],*/
    widgets: ['zebra'],
    headers: { 4: { sorter: false } }
  });

  // add onClick for all hash-Links that are on the same page
  if (hash == "") {
    if ($(".gs_content").find("h5[vid]").length > 0) {
      var hashParts = $(".gs_content").find("h5[vid]").first().attr("vid").split("-");
    } else if ($(".gs_content").find("h5[cid]").length > 0) {
      var hashParts = $(".gs_content").find("h5[cid]").first().attr("cid").split("-");
    } else
      var hashParts = "";
    if (hashParts != "") {
      hashParts.pop();
      var hashPartForInternalLinks = "#" + hashParts.join("-");
    }
  } else {
    var hashParts = hash.split("-");
    hashParts.pop();
    var hashPartForInternalLinks = hashParts.join("-");
  }
  $(this).on('click', "a:not(.active)[href*='" + hashPartForInternalLinks + "']", function (e) {
    e.preventDefault();
    var linkHash = $(this).attr('href');
    if (linkHash.indexOf('#') > 1) {
      linkHash = linkHash.split('#')[1];
    }
    jumpBrand(linkHash);
  });

});

function getParam(name) {
  if (location.search.indexOf(encodeURIComponent(name)) >= 0)
    if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search)) {
      return decodeURIComponent(name[1]);
    } else
      return false;
  else
    return false;
}

/* check code for jump brand */
function jumpBrand(hash) {

  // initialize requested element
  if (hash.length > 0) {
    // in case of additional parameter
    if (hash.indexOf('?') > 0) {
      hash = hash.substr(0,hash.indexOf('?'));
    }

    hash = hash.replace("#", "");

    if (hash.indexOf('-') > 0) {
      
      // Defult cases:
      var li = $("details[vid='" + hash + "']");

      if (li.length < 1) {
        li = $("details[cid='" + hash + "']");
      }

      // Expand parent Accordeon (Only EU-SILC) + target vid if not opened
      var isSILC;
      isSILC = $(location).attr('pathname').search("EU-SILC");
      
      if (isSILC != -1){
        parentDiv = li.parent().parent().children();
        if (parentDiv.length > 0) { // Überprüfen, ob parentDiv Elemente enthält
          parentDiv[0].click();
        }
      }
      
      li.children().click();
    }

    // Sleep timer je Browser:
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (li !== undefined){
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
      {
        if (li.length > 0) {
          $('html, body').animate({ scrollTop: (li.offset().top) }, 'slow');
        }
      }
      else  // If another browser
      {
        if (li.length > 0) {
          function partA() {
            // Sleep timer to 1/2 sek
            window.setTimeout(partB, 500);
          }

          function partB() {
            $('html, body').animate({ scrollTop: (li.offset().top -60) }, 'slow');
          }
          partA();
        }
      }
    }
  }
}

// Initialize to used in HTML combined with npm webpack:
window.jumpBrand = jumpBrand;

/* get base url */
function getBaseUrl() {
  var url = window.location.href.split('/');
  //return url[0] + '//' + url[2] + "/";
  return "http://www.gesis.org/";
}

// Compare Elements

/* Add new compare field */
function addCompareElement(numberOfElement) {
  var divHtml = '<div class="element ui-droppable" id="element_' + numberOfElement + '"><div class="remove removeElement invisible"><img src="http://www.gesis.org/uploads/pics/remove_round_small_white.png"/></div><p>Place element here</p></div>';
  $('#compareElements').append(divHtml);
  $('#element_' + numberOfElement).droppable(droppableOptions);

  $('[id^=element_]').each(function () {
    var aryClasses = $(this).attr('class').split(' ');

    for (var i = 0; i < aryClasses.length; i++) {
      if (aryClasses[i].indexOf('elements') !== -1) {
        $(this).removeClass(aryClasses[i]);
      }
    }

    if (numberOfElement === 2) {
      $(this).addClass('elements2');
    } else if (numberOfElement === 3) {
      $(this).addClass('elements3');
    } else {
      $(this).addClass('elements4');
    }
  });
}

/* Define droppable, check if elements are the same level and add element to hidden-field "#chosenElements" */
var droppableOptions = {
  hoverClass: "elementHover",
  addClasses: true,
  drop: function (event, ui) {
    var source = ui.helper.attr('variable');

    var copynode;
    var output = "";
    var idNumber = 0;
    var elementLength = 0;
    if (source) {
      copynode = source;
      if (idNumber === 0) {
        var splitFromTitleAndID = copynode.split('=');
        var keyArray = splitFromTitleAndID[0].split('_');
        var key = "";
        for (var i = 0; i < keyArray.length; i++) {
          key += keyArray[i];
          if (i < keyArray.length - 1) {
            output += keyArray[i].replace(/#/g, ' ');
            key += "_";
            output += "/<br/>";
          } else {
            output += keyArray[i].replace(/#/g, ' ').replace('=', '<br/>');
          }
        }
        idNumber++;
        elementLength = keyArray.length - 1;
      }
    } else {
      copynode = { title: "This node was dropped here (" + ui.helper + ")." };
    }

    var chosenElements = $('#chosenElements').attr("value");
    if (chosenElements.indexOf(copynode) < 0) {
      var chosenElementLength = 0;
      var chosenKeys = chosenElements.split("&");
      var replacedKey = false;
      chosenElements = "";
      for (var j = 1; j < chosenKeys.length; j++) {
        var elementKey = chosenKeys[j].split("=");
        if (elementKey[0].indexOf($(this).attr("id")) > -1) {
          replacedKey = true;
          elementKey[1] = copynode;
        }
        var splitFromTitleAndID = elementKey[1].split('=');
        var keyParts = splitFromTitleAndID[0].split("_");
        chosenElements += "&" + elementKey[0] + "=" + elementKey[1];
      }

      if (!replacedKey) {
        chosenElements += "&" + $(this).attr("id") + "=" + copynode;
      }
      $(this).attr("keyid", copynode);
      $(this).find("p").html(output);
      $(this).addClass("setElement");
    }
  }
};

$('#compareFrame').ready(function () {
  /*Compare Elements*/
  /* TODO */
  var chosenElements = null;
  //var chosenElements = $.urlParam('chosenElements');
  //$('#chosenElements').prop("value", chosenElements);
  var numberOfElements = 2;

  /**
   * Fill Elements into boxes if chosenElements Parameter is set
   */
  if (chosenElements !== null) {
    var elements = chosenElements.split("&");
    for (var i = 1; i < elements.length; i++) {
      var output = "";
      var elementParts = elements[i].split("=");
      var keyArray = elementParts[1].split('_');
      for (var j = 0; j < keyArray.length; j++) {
        output += keyArray[j].toUpperCase();
        if (j < keyArray.length - 1) {
          output += "/<br/>";
        }
      }
      if (i > numberOfElements) {
        numberOfElements++;
        addCompareElement(numberOfElements);
      }
      $('#' + elementParts[0]).find("p").html(output);
      $('#' + elementParts[0]).prop("keyID", elementParts[1]);
      $('#' + elementParts[0]).addClass("setElement");
    }
    $('[id^=element_]').each(function () {
      var aryClasses = $(this).attr('class').split(' ');

      for (var i = 0; i < aryClasses.length; i++) {
        if (aryClasses[i].indexOf('elements') !== -1) {
          $(this).removeClass(aryClasses[i]);
        }
      }

      if (keyArray.length === 2) {
        $(this).addClass('elements2');
      } else if (keyArray.length === 3) {
        $(this).addClass('elements3');
      } else {
        $(this).addClass('elements4');
      }
    });
  }

  $("[id^=element_]").droppable(droppableOptions);

  var addElement = function () {
    numberOfElements++;
    addCompareElement(numberOfElements);
  };
  $('#addElement').click(addElement);

});

/**
  * FUNCTIONS FOR TABLE ADJUSTMENT
  */
/* automatic adjustment of tablerow height */
function adjustHeightOfHeadcol() {

  $('.headcol').each(function () {
    // $(this).css('height', '');
    // $(this).next().css('height', '');

    if ($(this).parent().attr('concept') == 'Level_of_education_and_training') {
      if ($(this).has('h4').length) { }
      //window.alert('Level_of_education_and_training: '+$(this).has('h4').outerHeight()+' - '+$(this).next().outerHeight());
    }

    //if ( $(this).has('h4').length >= 0 || $(this).has('h5').length >= 0 ) {
    if ($(this).height() < $(this).next().height()) {
      $(this).height($(this).nextAll(':visible:first').height());
    } else if ($(this).height() > $(this).next().height()) {
      $(this).nextAll(':visible:first').height($(this).height());
    }
    //}
  });

  //if (! $.timers.length) {
  updateRowStripes(".X_tableZebra");
  //}
}
/* update row stipes of given table */
function updateRowStripes(tableClasses) {
  if (tableClasses != "") {
    $("table" + tableClasses + " tr").removeClass("odd").removeClass("even");
    $(tableClasses + " li").removeClass("odd").removeClass("even");

    // cycle per table
    $("table" + tableClasses).each(function (tableElementIndex, tableElementValue) {
      $(this).find("tr:visible:even").addClass("odd");
      $(this).find("tr:visible:odd").addClass("even");
    });
    //$("table"+tableClasses+" tr:visible:even").addClass("odd");
    //$("table"+tableClasses+" tr:visible:odd").addClass("even");

    $("" + tableClasses + " li:visible:even").addClass("odd");
    $("" + tableClasses + " li:visible:odd").addClass("even");
  }
}

/**
  * OTHER ADJUSTMENTS
  */
function toggleDisplay(id, attr, display, tableClasses, cssClass) {
  if (cssClass === undefined) {
    cssClass = 'hide';
  }

  if (id === null) {
    if (display === null) {
      $('table.M_TableContent tr').toggleClass('d-none');
      $('table.M_TableContent td').toggleClass('d-none');
      $('table.M_TableContent th').toggleClass('d-none');
    } else if (display) {
      $('table.M_TableContent tr').removeClass('d-none');
      $('table.M_TableContent td').removeClass('d-none');
      $('table.M_TableContent th').removeClass('d-none');
    } else {

    }
  } else {
    if (attr === '.' || attr === '#') {
      if (display === null) {
        $(attr + id).toggleClass(cssClass);
      } else if (display)
        $(attr + id).removeClass(cssClass);
      else
        $(attr + id).addClass(cssClass);
    } else {
      if (display === null) {
        $("[" + attr + "=" + id + "]").toggleClass(cssClass);
      } else if (display) {
        $("[" + attr + "=" + id + "]").removeClass(cssClass);
      } else {
        $("[" + attr + "=" + id + "]").addClass(cssClass);
      }
    }
  }

  if (tableClasses !== null) updateRowStripes(tableClasses);
}
// check if child-lists are expanded
function checkForToggleAll(parentList) {
  var countExpanded = parentList.find('img[src$="expand_blue.png"]').length;

  if (countExpanded > 0) {
    parentList.find('img[toggleAll]').attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/expand_all_blue.png");
  } else {
    parentList.find('img[toggleAll]').attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/collapse_all_blue.png");
  }

  // return true if there are expanded elements
  return (countExpanded > 0);
}

/**
  * TABS CONFIG
  */
/* normal tabs */
var tabConfig = function (element) {
  var tabSelector = "ul.tabs";
  var targetElement = (element != null ? element.find(tabSelector) : tabSelector);
  $(targetElement).each(function () {
    // For each set of tabs, we want to keep track of
    // which tab is active and it's associated content
    var $active, $content, $links = $(this).find('a');

    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    $active = $($links.filter('[href="' + location.hash + '"]')[0] || $links[0]);
    $active.addClass('active');

    $content = $($active[0].hash);

    $content.addClass('currentTab');
    // Hide the remaining content
    $links.not($active).each(function () {
      $(this.hash).removeClass('currentTab');
    });

    // Bind the click event handler
    $(this).on('click', 'a:not(.disabled)', function (e) {
      // Make the old tab inactive.
      $active.removeClass('active');
      $content.removeClass('currentTab');

      // Update the variables with the new link and content
      $active = $(this);
      $content = $(this.hash);

      // Make the tab active.
      $active.addClass('active');
      $content.addClass('currentTab');

      // Prevent the anchor's default click action
      e.preventDefault();

      $('.M_TableContent').promise().done(function () {
        adjustHeightOfHeadcol();
        $('.M_scrollableOuter:visible').doubleScroll();
      });
    });
  });
};
/* country tabs */
var countryTabConfig = function (element) {
  var tabSelector = ".countryTabbing";
  var targetElement = (element != null ? element.find(tabSelector) : tabSelector);
  $(targetElement).each(function () {
    // For each set of tabs, we want to keep track of
    // which tab is active and it's associated content
    var $active, $content, $links = $(this).find('a');
    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    $active = $($links.filter('[value="' + location.search + '"]')[0] || $links[0]);
    var browserLocation = location.search;
    if ($active.length > 0) {

      $active.toggleClass('active');
      // console.log($active[0].value);
      $content = document.getElementById($active[0].attributes['value'].value.replace("?", ""));
      // Hide the remaining content
      $content.attributes.class.value = '';
      $links.not($active).each(function () {
        $(this.hash).addClass('d-none');
      });
      // Bind the click event handler
      $(this).on('click', 'a:not(.disabled)', function (e) {
        // Make the old tab inactive.
        $active.toggleClass('active');
        $content.attributes.class.value = 'd-none';
        // Update the variables with the new link and content
        $active = $(this);
        $content = document.getElementById($active[0].attributes['value'].value.replace("?", ""));
        // Make the tab active.
        $active.toggleClass('active');
        $content.attributes.class.value = '';
        // Prevent the anchor's default click action
        e.preventDefault();
        // Update browser URL
        window.history.replaceState(location.href, browserLocation, $active[0].attributes['value'].value);
      });
    }
  });
};

/* Subnav */
$(document).on("click", ".openSubnav", function (event) {
  event.stopPropagation();
  event.preventDefault();
  var elementToToggle = $(this).children().attr('id');
  $('#' + elementToToggle).toggleClass("menuOpened", 10);
  $('[id^=' + elementToToggle + 'List]').toggleClass("d-none", 10);
});

/* Expand for floating Menue MD-Box */
$(document).on("click", "#MD_Header:not(.unclickable)", function (event) {
  $("#MD_ListOuter").toggleClass("M_ListTopNavContentExpand02", 200);
  $("#MD_ListInner").toggleClass("d-none", 1);
  $("#MD_Footer").toggleClass("d-none", 1);
  if ($('#BoxID_SaveText #saveText_alert em').text().trim().length)
    $("#BoxID_SaveText").toggleClass("d-none", 1);
  return false;
});
$(document).on("click", "#MD_Footer:not(.unclickable)", function (event) {
  $("#MD_ListOuter").toggleClass("M_ListTopNavContentExpand02", 200);
  $("#MD_ListInner").toggleClass("d-none", 1);
  $("#MD_Footer").toggleClass("d-none", 1);
  if ($('#BoxID_SaveText #saveText_alert em').text().trim().length)
    $("#BoxID_SaveText").toggleClass("d-none", 1);
  return false;
});

/* load variable details on click */
$(document).on("click", "summary[keyid]", function (event) {
  var parentElement;
  var variableKey;
  var variableValue;
  var listElement = $(this).next('div');

  // we only need the part in front of the "=" as filename
  variableKey = $(this).attr('keyID').split('=');
  variableValue = variableKey.toString().split('+');

  //var variableKey = $(this).nextAll('img[keyID]').attr('keyID').split('=');
  var pathnameA, pathnameB;
  pathnameA = $(location).attr('pathname').replace('original', '').replace('thematic', '');
  pathnameA = $(location).attr('origin') + pathnameA;
  var variableFile = pathnameA + "variable/" + (variableKey[0].replace(/_/g, '')) + ".html";
  pathnameSplitted = $(location).attr('pathname').split("/");
  pathnameB = pathnameSplitted[0] + "/" + pathnameSplitted[1] + "/metadata/MZ/availability/" + pathnameSplitted[5].replace('Cross-sectional', 'cross-sec') + "/";
  var availabilityByLineFile = pathnameB + variableValue[1].replace(/_/g, '') + ".html";

  listElement.load(variableFile, function () {
    tabContainersElements = this.querySelectorAll("div.tabs");
    tabsContainers = initializeTabContainers(tabContainersElements);

    const infoButtons = this.querySelectorAll('span[aria-controls]');
    for (infoButton of infoButtons) {
      const controlledDialogElementId = infoButton.getAttribute('aria-controls');
      const controlledDialogElement = document.getElementById(controlledDialogElementId);
      if (controlledDialogElement) {
        initializeDialog(controlledDialogElement);
        infoButton.addEventListener('click', () => controlledDialogElement.showModal());
      }
    }

    var isMZ;
    isMZ = $(location).attr('pathname').search("MZ");

    if (isMZ != -1){
      var targetElement = document.querySelector('#AV-'+variableValue[1].replace(/_/g, ''));
      try{
        fetch(availabilityByLineFile)
        .then(response => response.text())
        .then(data => {
          // Extrahiere den Inhalt des div-Elements mit der ID "1238731"
          targetElement.innerHTML = data;

          // Label Jahr mit strong hervorheben
          const yearToFind = pathnameSplitted[4];

          const years = targetElement.querySelectorAll("span.year");

          for (let i = 0; i < years.length; i++) {
            const actYear = years[i];
            const yearText = actYear.textContent; // z.B. "2022 | "
          
            if (yearText.startsWith(yearToFind)) {
              // 1) year-Span weiß färben
              actYear.classList.add("text-white");
              // Optional, falls es sonst überschrieben wird:
              // actYear.classList.remove("text-secondary");
          
              // 2) Link finden (nächster <span> enthält <a>)
              const link = actYear.nextElementSibling?.querySelector("a")
                       ?? actYear.parentElement?.querySelector("a");
              if (link) {
                // Klick deaktivieren
                link.removeAttribute("href");
                link.style.pointerEvents = "none";
                link.style.cursor = "default";
                link.setAttribute("aria-disabled", "true");
          
                // Link weiß färben
                link.classList.add("text-white");
              } else {
                console.error("Kein <a>-Element gefunden.");
              }

              // Übergeordnetes <div> finden
              const parentDiv = actYear.closest("div");
              if (parentDiv) {
                parentDiv.classList.remove("gs-light--14"); // alte BG-Farbe entfernen
                parentDiv.classList.add("gs-pink");        // neue BG-Farbe setzen
              } else {
                console.error("Kein übergeordnetes <div>-Element gefunden.");
              }
            }
          }
        }
        );
      }
      catch(e){
        console.log(e);
      }
    }

    // adjust availability Links
    $('.X_availabilityWrapper a').each(function () {
      var originalHref = $(this).attr('href');
      var actualUrl = window.location.href;
      var endOfUrl;

      if (actualUrl.indexOf('#') > 0)
        endOfUrl = actualUrl.indexOf('#');
      else
        endOfUrl = actualUrl.length;

      var cutUrl = actualUrl.substring(0, endOfUrl);
      var varlistType = cutUrl.substring(cutUrl.lastIndexOf('/') + 1);

      if (varlistType != "browse-via-topic")
        $(this).attr('href', originalHref.replace('original', varlistType));
    });

    // find Hash-Links (only hash without absolute link infront) and add link
    $('div.tabContent').each(function (index, tab) {
      $(tab).find($('a')).each(function () {
        var originalHref = $(this).attr('href');

        if (originalHref.indexOf('#') == 0) {
          $(this).on('click', function (e) {
            e.preventDefault();
            $(listElement).find('.tabs a[href="' + originalHref + '"]').click();
          });
        }
      });
    });

    tabConfig(listElement);
    countryTabConfig(listElement);
    // draggableVariable();

    // onclick to add the actual tab
    $(this).on('click', '.X_availabilityWrapper a', function (event) {
      event.stopPropagation();
      event.preventDefault();
      var destination = $(this).attr('href');
      var activeTab = $(this).parents('.X_availabilityWrapper').prevAll('.currentTab');
      var tabId = activeTab.attr('id');
      var cutTabId = tabId.substring(tabId.indexOf('_'), tabId.length);
      destination = destination + cutTabId;
      window.location.href = destination;
    });
  });
});

/* expand/collapse single list-element */
$(document).on("click", ".expandable:not([toggleAll])", function (event) {
  event.stopPropagation();
  event.preventDefault();

  if ($(this).parents('.X_tableZebra').length > 0) {
    var isVisible;
    if ($(this).parents('th.headcol').length > 0) {

      if ($(this).parents('tr[concept]').length > 0) {
        var rowToHide = $(this).parents('tr').attr('concept');
      }
      else {
        var rowToHide = $(this).attr('id');
      }

      // the pivot element, a row where expand/collapse button clicked
      var clickedRowElement = $('[concept="' + rowToHide + '"]:visible');

      // check visibility of first child/next row
      isVisible = clickedRowElement.next().is(':visible');

      // prepare a stack for traversing table
      var conceptStack = [];

      // at first push first root node (clicked node)
      conceptStack.push(rowToHide);
      $.each(clickedRowElement.nextAll(), function (index, item) {

        // first, get parent node
        var parentNodeName = $(item).attr("id");

        // root element doesn't have id, just continue
        if (typeof parentNodeName === "undefined") {
          return false;
        }

        // if on collapse tree and element already invisible, just skip
        if (isVisible && !$(item).is(':visible')) {
          return;
        }

        // get concept parent
        var rowIndex = parentNodeName.indexOf("Row")
        if (rowIndex !== -1) {
          parentNodeName = parentNodeName.substring(0, rowIndex);
        }

        // push to stack if traverse down
        if (conceptStack[conceptStack.length - 1] === parentNodeName) {
          if (conceptStack[conceptStack.length - 1] !== $(item).attr("concept")) {
            conceptStack.push($(item).attr("concept"));
            // change image icon 
            if (!isVisible)
              $(item).find("img.expandable").attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/collapse_blue.png");
          }
        }
        //remove from stack if traverse up
        else {
          var conceptIndex = conceptStack.indexOf(parentNodeName);
          if (conceptIndex == -1) {
            return false;
          }

          // cut array to certain index
          conceptStack.splice(conceptIndex + 1, conceptStack.length - conceptIndex);

          // insert new concept
          conceptStack.push($(item).attr("concept"));

          // change image icon 
          if (!isVisible)
            $(item).find("img.expandable").attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/collapse_blue.png");
        }

        if (!isVisible) {
          // only show direct child
          if (parentNodeName === rowToHide) {
            $(item)
              .removeClass("d-none")
              .attr("height", $(item).find(">:first-child").outerHeight(true));
          }
        }
        else
          $(item).addClass("d-none");
      });

      // change/toggle image of the clicked tree expand/collapse button
      if (isVisible) {
        $(this).attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/collapse_blue.png");
      }
      else {
        $(this).attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/expand_blue.png");
      }
      $('[id^="' + rowToHide + 'Row"]').promise().done(function () {
        adjustHeightOfHeadcol();
      });
    } else {
      var columnToHide = $(this).parent().attr('id');
      isVisible = $(this).prev('span').is(':visible');
      $('#' + columnToHide + ' span').toggleClass("d-none");
      $('.' + columnToHide + ' span').toggleClass("d-none");
      $('.' + columnToHide).toggleClass("isCollapsed");

      if (isVisible) {
        $('#' + columnToHide + ' img.expandable').attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/collapse_blue.png");
      } else {
        $('#' + columnToHide + ' img.expandable').attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/expand_blue.png");
      }
      adjustHeightOfHeadcol();
    }
  } else {
    var countryID = $(this).parents('li[id]').attr('id') || null;
    var listElement = ($(this).parent().next('ul').length > 0) ? $(this).parent().next('ul') : $(this).parent().next('div');
    var isVisible = listElement.is(':visible');

    if (isVisible) {
      $(this).attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/collapse_blue.png");
    } else {
      $(this).attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/expand_blue.png");
    }

    listElement.toggleClass('d-none');

    if ($(this).parent().next('div').length > 0 && !$(this).parent().next('div').text().trim().length) {
      var parentElement;
      var variableKey;
      if ($(location).attr('pathname').indexOf('browse') >= 0) {
        parentElement = $(this).closest('li.metaMatrixLeaf[id]');
        variableKey = parentElement.attr('id').split('=');
      } else {
        parentElement = $(this).closest('li[keyID]');
        variableKey = parentElement.attr('keyID').split('=');
      }

      //var variableKey = $(this).nextAll('img[keyID]').attr('keyID').split('=');
      var pathname;
      if ($(location).attr('pathname').indexOf('browse') >= 0) {
        pathname = "missy/eu/metadata/";
        var splitted = variableKey[0].split("_");
        $.each(splitted, function (key, value) {
          if (key < splitted.length - 1)
            pathname += value + "/";
        });
      } else
        pathname = $(location).attr('pathname').replace('original', '').replace('thematic', '');
      var variableFile = pathname + "variable/" + (variableKey[0].replace(/_/g, '')) + ".html";
      listElement.load(variableFile, function () {

        // adjust availability Links
        $('.availabilityDiv a').each(function () {
          var originalHref = $(this).attr('href');
          var actualUrl = window.location.href;

          var endOfUrl;
          if (actualUrl.indexOf('#') > 0) {
            endOfUrl = actualUrl.indexOf('#');
          }
          else {
            endOfUrl = actualUrl.length;
          }

          var cutUrl = actualUrl.substring(0, endOfUrl);
          var varlistType = cutUrl.substring(cutUrl.lastIndexOf('/') + 1);

          if (varlistType != "browse-via-topic")
            $(this).attr('href', originalHref.replace('original', varlistType));
        });

        tabConfig(listElement);
        countryTabConfig(listElement);
        draggableVariable();

        // onclick to add the actual tab
        $(this).on('click', '.availabilityDiv a', function (event) {
          event.stopPropagation();
          event.preventDefault();
          var destination = $(this).attr('href');
          var activeTab = $(this).parents('.availabilityDiv').prevAll('.currentTab');
          var tabId = activeTab.attr('id');
          var cutTabId = tabId.substring(tabId.indexOf('_'), tabId.length);
          destination = destination + cutTabId;
          window.location.href = destination;
        });
      });
    }

    // toggle equivalent elements of all other countries
    if ($(this).parents('ul.countrySpecificInformation').length > 0 && countryID != null) {
      var actualLi = $(this).parents('li');
      var index = $(this).parents('ul').children('li').index(actualLi);
      $links = $('ul.countryTabs').find('a[href]');
      $links.each(function () {
        if (this.hash != "#" + countryID) {
          var list = $(this.hash).find('ul').children('li').eq(index);

          if (isVisible) {
            list.find('img.expandable').attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/collapse_blue.png");
            list.find('div.M_accArea').addClass('d-none');
          } else {
            list.find('img.expandable').attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/expand_blue.png");
            list.find('div.M_accArea').removeClass('d-none');
          }
        }
        checkForToggleAll($(this.hash));
      });
    }

    checkForToggleAll($(this).parents('li[id]'));
  }
});
/* expand/collapse all narrower list-elements */
$(document).on("click", ".expandable[toggleAll]", function (event) {
  event.stopPropagation();
  event.preventDefault();
  var parentList = ($(this).parents('li[id]').length > 0) ? $(this).parents('li[id]') : $(this).closest('li');
  var expandedElements = checkForToggleAll(parentList);
  var countryID = $(this).parents('li[id]').attr('id') || null;
  var listElements = parentList.find(".expandable:not([toggleAll]):visible").closest('li');
  $.each(listElements, function (key, value) {
    var toggleElement = ($(this).children('ul').length > 0) ? $(this).children('ul') : $(this).children('div.M_accArea');
    var toggleImg = $(this).find('.expandable');
    if (toggleElement.is(':visible') && expandedElements) {
      toggleElement.toggleClass('d-none');
      toggleImg.attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/collapse_blue.png");
    } else if (toggleElement.is(':hidden') && !expandedElements) {
      toggleElement.toggleClass('d-none');
      toggleImg.attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/expand_blue.png");
    }
  });

  if ($(this).parents('ul.countrySpecificInformation').length > 0 && countryID != null) {
    var actualLi = $(this).parents('li');
    var index = parentList.children('ul:first').children('li').index(actualLi);
    $links = $('ul.countryTabs').find('a[href]');
    $links.each(function () {
      if (this.hash != "#" + countryID) {
        $listElements = $(this.hash).find('ul').children('li');
        $listElements.each(function () {
          if (expandedElements) {
            $(this).find('img.expandable').attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/collapse_blue.png");
            $(this).find('div.M_accArea').addClass('d-none');
          } else {
            $(this).find('img.expandable').attr('src', "http://www.gesis.org/fileadmin/missy/MISSY3/images/icons/expand_blue.png");
            $(this).find('div.M_accArea').removeClass('d-none');
          }
        });
      }
      checkForToggleAll($(this.hash));
    });
  }
  checkForToggleAll(parentList);
});

/* use element in compare elements */
$(document).on("click", "[function=useElement]", function (event) {
  event.stopPropagation();
  event.preventDefault();
  var variableKey = $(this).parents('[variable]').attr('variable');
  var elementSet = false;
  var elementCount = $('[id^=element_]').length;
  var setElementCount = $('[id^=element_][keyID]').length;
  if (elementCount === setElementCount) {
    var nextElementID = elementCount + 1;
    addCompareElement(nextElementID);
  }

  $('[id^=element_]').each(function () {
    if ($(this).attr('keyID') === undefined && !elementSet) {
      var keyArray = variableKey.split('_');
      var output = "";
      for (var j = 0; j < keyArray.length; j++) {
        if (j === keyArray.length - 1) {
          output += (keyArray[j].split('='))[0].toUpperCase();
        }
        else {
          output += keyArray[j].toUpperCase();
        }
        if (j < keyArray.length - 1) {
          output += "/<br/>";
        }
      }
      $(this).attr('keyID', variableKey);
      $(this).find("p").html(output);
      $(this).addClass("setElement");
      elementSet = true;
    }
  });
});

$(document).on('click', '#openCompareChosenVariables', function () {
  var selectedIds = "";

  // append the url with query string
  $("div#compareElements > div").each(function (index) {
    var varKeyId = $(this).attr("keyid");
    if (typeof varKeyId !== "undefined") {
      if (index > 0) {
        selectedIds += ";";
      }
      selectedIds += varKeyId;
    }
  });

  // get the compare content via ajax
  var resultPageUrl = "missy/eu/work-with-mymetadata/compare-results";

  if (selectedIds != "") {
    window.location = resultPageUrl + "?variableIds=" + encodeURIComponent(selectedIds);
  }

});

$(document).on('click', '.openFullscreen', function () {

  var selectedIds = "";
  if ($('input[name=variableIds]').length > 0) {
    selectedIds = $('input[name=variableIds]').attr('value');
  }
  // get the compare content via ajax
  var fullscreenPageUrl = window.location.href + "-Fullscreen";

  if (selectedIds != "") {
    fullscreenPageUrl = fullscreenPageUrl + "?variableIds=" + encodeURIComponent(selectedIds);
  }

  window.open(fullscreenPageUrl, document.title + " Fullscreen", "scrollbars=yes,toolbar=no,location=no,copyhistory=no");
});

/** Compare Element **/
function getCompareElementViaAjax(comparatorUrl, containerSelector) {
  // change the url without reloading (HTML5 History API - Chrome, Safari, FF4+, and IE10)
  var simpleURL = window.location.href.split('?')[0];
  window.history.pushState("Variables comparison", "", simpleURL);

  // get the content
  $.get(comparatorUrl + "&ajax=true")
    .done(function (html) {
      $(containerSelector).html(html);
      tabConfig();
      countryTabConfig();
      adjustHeightOfHeadcol();
      $('.M_scrollableOuter:visible').doubleScroll();
      $(containerSelector + " div").promise().done(function () {
        filterAnimation(false);
        if ($('.Fullscreen').length > 0) {
          console.log('is compare');
          $('.openFullscreen').addClass('d-none');
        }
      });
    });
}

/* remove chosen element from compare */
$(document).on("click", '.removeElement', function () {
  var output = "Place element here";
  $(this).parent().find("p").html(output);
  $(this).parent().removeClass("setElement");
  $(this).parent().attr('keyID', null);
});

/* show/hide Filter-Box */
// WE: change [id$=ShowHide] to .M_OptionsLeft
//$(document).on("click", "[id$=ShowHide]", function(event) {
$(document).on("click", "span.M_OptionsLeft", function (event) {
  event.stopPropagation();
  event.preventDefault();
  var divToToggle = $(this).parents('div.M_Options').next('div');
  var isVisible = divToToggle.is(":visible");
  toggleDisplay(divToToggle.prop('id'), "#", !isVisible, null);
});

/* close Filter-Box */
$(document).on("click", "[id$=Close]", function (event) {
  event.preventDefault();
  var divToToggle = $(this).parent().parent();
  var isVisible = divToToggle.is(":visible");
  toggleDisplay(divToToggle.prop('id'), "#", !isVisible, null);
});

/* Custom Codebooks */
$(document).on("click", "input.buttonActive", function () {
  var destination = $(this).attr('destination');
  $('#' + destination).trigger('click');
});
$(document).on("click", 'input[name^="show_"]', function () {
  var additionalInformation = $(this).parent().next().find('div.additionalInformation');

  if (additionalInformation) {
    additionalInformation.toggleClass('disabled');
    var checkboxes = additionalInformation.find('input[type=checkbox]');
    checkboxes.prop('disabled', !checkboxes.prop('disabled'));
  }
});

/* Tooltip-On Click */
$(document).on("click", ".tooltip-info", function () {
  $(this).next().toggle();
});

/* Variabledetails: automatic click if the last level in the original/thematic list was opened */
$(document).on("click", '.gs_accordion-toggle:not([vid])', function () {
  var childrenH6 = $(this).next().find('div.m_accordion-nest').first().children('button.gs_accordion-toggle[vid]');
  if (childrenH6.length === 1) {
    childrenH6.first().trigger("click");
  }
});

/**
  * ONMOUSEENTER/-LEAVE-EVENTS
  */
$(document).on({
  mouseenter: function () {
    $(this).children('img.M_Options').removeClass('d-none');
  },
  mouseleave: function () {
    $(this).children('img.M_Options').addClass('d-none');
  }
}, ".expandableList .title, .M_MatricesTable .title");

$(document).on({
  mouseenter: function () {
    if ($(this).find('.remove').length > 0)
      $(this).children('.remove').removeClass('invisible');
    else
      $(this).children('img.M_Options').removeClass('invisible');
  },
  mouseleave: function () {
    if ($(this).find('.remove').length > 0)
      $(this).children('.remove').addClass('invisible');
    else
      $(this).children('img.M_Options').addClass('invisible');
  }
}, '[id^=element_], #MD_Box .title');
$(document).on({
  mouseenter: function (event) {
    var el = $(this);
    var tooltip = el.attr("tooltip");
    if (tooltip.length > 0) {
      el.addClass("showTooltip");

      setTimeout(function () {
        if (el.hasClass("showTooltip")) {
          var tooltipDiv = '<div id="tooltip"></div>';
          if (el.is('th') || el.is('td'))
            el.append(tooltipDiv);
          else
            el.append(tooltipDiv);

          $("div#tooltip").append("<span>" + tooltip + "</span>");

          if (el.parent().is('a')) {
            $('div#tooltip').css({ "margin-top": "20px" });
            var textWidth = $('div#tooltip').width();
            if (textWidth >= 157) {
              $('div#tooltip').css({ "width": "200px" });
              var textWidthOutOfMD = $('div#tooltip span').width();
              if (textWidthOutOfMD <= 200)
                $('div#tooltip').css({ "width": textWidthOutOfMD });
            }
          }
        }
      }, 500);
    }
  },
  mouseleave: function (event) {
    $(this).removeClass("showTooltip");
    $("div#tooltip").remove();
  }
}, '[tooltip]');

/**
  * ONCHANGE-EVENTS
  */
/* Matrix-Filter */
$(document).on("change", "#tabcontent-filter:not(.NoTable) :checkbox", async function (event) {
  await fadeIn();
  var isChecked = $(this).is(":checked");

  if ($(this).attr('value') === 'checkAllYear') {
    $('[name^=' + $(this).attr('name') + ']').each(function (key, el) {
      var checkboxIsChecked = $(el).is(':checked');
      if (isChecked !== checkboxIsChecked) {
        $(this).prop('checked', isChecked);
        if ($(el).attr('name') === "year") {
          toggleDisplay($(el).attr("value"), "year", isChecked, ".M_TableContent");
        } else if ($(el).attr('name') === "filetype"){
          toggleDisplay($(el).attr("value"), "filetype", isChecked, ".M_TableContent");
        }
        
        // Only on EU-SILC
        var html = document.documentElement.outerHTML;
        if (html.includes('EU-SILC')) {

          var clickedDatasetSubType = Object.create(null);
          var clickedStudie = $(el).is(":checked");

          // if EU-SILC:
          // check clicked DatasetSubTypes
          $('#tabcontent-filter > div.row:nth-child(7) > div > div > div > label > input').each(function (key, el){
            clickedDatasetSubType[$(this).attr('value')]=$(this).is(":checked");
          });

          // Update colspan of studies
          var count = 0;
          for (var v in clickedDatasetSubType) {
            if (clickedDatasetSubType[v]) {
              count++;
            }
          }
          var thElements = document.querySelectorAll('tr.missyMatrixTableYears > th[year]');
          // Iterate over the selected elements and update their colspan attribute
          thElements.forEach(function(th) {
            th.setAttribute('colspan', count);
          });

          var studies = $(this);
          var inputs = studies.parent().find('input').not(':first')
          inputs.each(function() {
            if ($(this).is(":checked") && clickedDatasetSubType[$(this).attr('ft')] == false) { 
              $(this).click(); 
            }
            else if (!$(this).is(":checked") && clickedDatasetSubType[$(this).attr('ft')] == true) { 
              $(this).click(); 
            }
            else if (clickedStudie == false && $(this).is(":checked")){
              $(this).click(); 
            }
          });
        }
      }
    });
  } else if ($(this).attr('value') === 'checkAllTopic') {
    $('[name^=' + $(this).attr('name') + ']').each(function (key, el) {
      var checkboxIsChecked = $(el).is(':checked');
      if (isChecked !== checkboxIsChecked) {
        $(this).prop('checked', isChecked);
        if ($(el).attr('name') === "topic") {
          toggleDisplay($(el).attr("value"), "topic", isChecked, ".M_TableContent");
        }
      }
    });

    $('[name^=topicheading]').each(function (key, el) {
      var checkboxIsChecked = $(el).is(':checked');
      if (isChecked !== checkboxIsChecked) {
        $(this).prop('checked', isChecked);
        if ($(el).attr('name') === "topicheading") {
          toggleDisplay($(el).attr("value"), "topicheading", isChecked, ".M_TableContent");
        }
      }
    });
    
    $('[name^=themconcept]').each(function (key, el) {
      var checkboxIsChecked = $(el).is(':checked');
      if (isChecked !== checkboxIsChecked) {
        $(this).prop('checked', isChecked);
        if ($(el).attr('name') === "themconcept") {
          toggleDisplay($(el).attr("value"), "themconcept", isChecked, ".M_TableContent");
        }
      }
    });
  }  
    else {
    if ($(this).attr('name') === "year") {
      toggleDisplay($(this).attr("value"), "year", isChecked, ".M_TableContent");

      // Only on EU-SILC
      var html = document.documentElement.outerHTML;
      if (html.includes('EU-SILC')) {
        var clickedDatasetSubType = Object.create(null);
        var clickedStudie = $(this).is(":checked");

        // if EU-SILC:
        // check clicked DatasetSubTypes
        $('#tabcontent-filter > div.row:nth-child(7) > div > div > div > label > input').each(function (key, el){
          clickedDatasetSubType[$(this).attr('value')]=$(this).is(":checked");
        });

        // Update colspan of studies
        var count = 0;
        for (var vd in clickedDatasetSubType) {
          if (clickedDatasetSubType[vd]) {
            count++;
          }
        }

        var thElements = document.querySelectorAll('tr.missyMatrixTableYears > th[year]');
        // Iterate over the selected elements and update their colspan attribute
        thElements.forEach(function(th) {
          th.setAttribute('colspan', count);
        });

        var studies = $(this);
        var inputs = studies.parent().find('input').not(':first')
        inputs.each(function() {
          if ($(this).is(":checked") && clickedDatasetSubType[$(this).attr('ft')] == false) { 
            $(this).click(); 
          }
          else if (!$(this).is(":checked") && clickedDatasetSubType[$(this).attr('ft')] == true) { 
            $(this).click(); 
          }
          else if (clickedStudie == false && $(this).is(":checked")){
            $(this).click(); 
          }
        });
      }

    } else if ($(this).attr('name') === "filetype") {
      toggleDisplay($(this).attr("value"), "filetype", isChecked, ".M_TableContent");
      var show = $(this).is(':checked');
      
      // Only on EU-SILC
      var html = document.documentElement.outerHTML;
      if (html.includes('EU-SILC')) {
        var clickedDataSubType=$(this).attr("value");
        // Update hidden studie checkboxes
        $('#tabcontent-filter > div.row:nth-child(3) > div > div > label > input').each(function (key, el){
          if ($(el).attr('name') === "year") {
            if ($(el).is(":checked") === true) {            
              // Get the parent element
              var parent = $(el).parent();
              var inputs = parent.find('input').not(':first')
              inputs.each(function() {
                if ($(this).attr('ft') == clickedDataSubType && show === true && $(this).is(":checked") === false){
                  $(this).click();
                } else if ($(this).attr('ft') == clickedDataSubType && show === false && $(this).is(":checked") === true){
                  $(this).click();
                }
              });
            }
          }
        });

        // Update colspan of studies
        var clickedDatasetSubType = Object.create(null);
        $('#tabcontent-filter > div.row:nth-child(7) > div > div > div > label > input').each(function (key, el){
          clickedDatasetSubType[$(this).attr('value')]=$(this).is(":checked");
        });
        var count = 0;
        for (var v in clickedDatasetSubType) {
          if (clickedDatasetSubType[v]) {
            count++;
          }
        }
        var thElements = document.querySelectorAll('tr.missyMatrixTableYears > th[year]');
        // Iterate over the selected elements and update their colspan attribute
        thElements.forEach(function(th) {
          th.setAttribute('colspan', count);
        });
      }

    } else if ($(this).attr('name') === "yearfiletype") {
      toggleDisplay($(this).attr("value"), "yearfiletype", isChecked, ".M_TableContent");
      var show = $(this).is(':checked');
      var colspan = $('.M_Colspans th').attr('colspan');
      
    } else if ($(this).attr('name') === "topic") {
        toggleDisplay($(this).attr("value"), "topic", isChecked, ".M_TableContent");
        var t = $(this).attr("value");
      
        // Es gibt 3 logische bezeichnungen:
        //  - topic: Übersschrift der Kategorie 
        //  - topicheading: Unsichtbare checkbox
        //  - themconcept: unterstes Element von unterste Ebene
        //
        // Checkboxen haben mehrere logische Aufgaben:
        //  - Erste Checkbox (Sichtbar): Blendet Tabellen Inhalt ein/aus
        //  - Zweite Checkbox (Unsichtbar): Klappt Accordeon auf/zu + Checkt (n) checkboxen unter dem ausgewähltem Element ein/aus
      
        var rows = document.querySelector("summary > input[value=" + t + "]").parentNode.parentNode.children[1].childNodes;
        rows.forEach(function (key, el) {
          if ($(key)[0].nodeName == "DETAILS" || $(key)[0].nodeName == "DIV") {
            try {
              section = $(key)[0].children[0].children[0].name;
            }
            catch (e) {
              section = "themconcept";
            }

            // All Topics:
            if (section == "topic") {
              // Checkbox checked:
              if (document.querySelector("summary > input[value=" + t + "]").checked == true) {
                document.querySelector("summary > input[value=" + t + "]").parentElement.parentElement.setAttribute("open","");

                // Heading Element:
                if (document.querySelector('summary > input[name="topicheading"][value="' + t + '"]').checked == false){
                  document.querySelector('summary > input[name="topicheading"][value="' + t + '"]').click();
                }

                // Elements in table:
                if($(key)[0].children[0].children[0].checked == false){
                  $(key)[0].setAttribute("open","");
                  $(key)[0].children[0].children[0].click();
                }
              } 
              // Checkbox uncheck:
              else {
                document.querySelector("summary > input[value=" + t + "]").parentElement.parentElement.removeAttribute("open");

                // Heading Element:
                if (document.querySelector('summary > input[name="topicheading"][value="' + t + '"]').checked == true){
                  document.querySelector('summary > input[name="topicheading"][value="' + t + '"]').click();
                }

                // Elements in table:
                if($(key)[0].children[0].children[0].checked == true){
                  $(key)[0].removeAttribute("open","");
                  $(key)[0].children[0].children[0].click();
                }                
              }
            } 
            // All Themconcepts:
            else {
              // Checkbox checked:
              if (document.querySelector("summary > input[value=" + t + "]").checked == true) {
                if (document.querySelector('summary > input[name="topicheading"][value="' + t + '"]').checked == false){
                  document.querySelector('summary > input[name="topicheading"][value="' + t + '"]').click();
                }
                if ($(key)[0].children[0].children[0].checked == false) {
                  $(key)[0].children[0].children[0].click();
                }
              }
              // Checkbox uncheck:
              else {
                // Heading Element:              
                if (document.querySelector('summary > input[name="topicheading"][value="' + t + '"]').checked == true){
                    document.querySelector('summary > input[name="topicheading"][value="' + t + '"]').click();
                  }
                if ($(key)[0].children[0].children[0].checked == true) {
                  $(key)[0].children[0].children[0].click();
                }
              }
            }
          }
        });
      } else if ($(this).attr('name') === "topicheading") {
        // Ein-/ausblenden von Überschrift der kategorie (click auf unsichtbare Checkbox: topic-Kopf)
        toggleDisplay($(this).attr("value"), "topic", isChecked, ".M_TableContent");

        // Verhalten: Wenn unsichtbare "topicheading" Checkbox angehakt wird, 
        // ist die zuhörige Überschrift (Kategorie "topicheading") mittels click auf Unsichtbaren checkbox, ein bzw. auszublenden.
      
        // Identifizierung: zuhörige Übersschrift (parentElement):
        var parentNodeStructure = $(this)[0].parentElement.parentElement.parentElement.parentElement.childNodes;
        var parentTopicHeadingElement = false;
        parentNodeStructure.forEach(function (key, el) {
          if ($(key)[0].nodeName == "SUMMARY") {
            try {
                parentTopicHeadingElement = $(key)[0].children[2];
            }
            catch (e) {
              console.log("Error:" + e);
            }
          }
        });

        // Ist bereits ein unsichtbare checkbox auf der Ebene angehakt (und wurde dadurch bereits die unsichtbare checkbox angehakt) ? 
        // var clickLevelThemconceptElements = $(this)[0].parentElement.parentElement.parentElement.parentElement.parentElement.childNodes[1].childNodes;
        var clickLevelTopicheadingElements = $(this)[0].parentElement.parentElement.parentElement.childNodes;
        var oneClickLevelTopicheadingElement = false;

        clickLevelTopicheadingElements.forEach(function (key, el) {
          if ($(key)[0].nodeName == "DETAILS") {
            try {
              if ($(key)[0].children[0].children[2].checked) {
                oneClickLevelTopicheadingElement = true;
              }
            }
            catch (e) {
              console.log("Error:" + e);
            }
          }
        });
     
        // 2 Different conditions to click invisible checkbox (Logic "going upstairs"):
        // 1. IF (any Checkbox of "topicheading" level is checked) AND (parent Element "topicheading" is NOT ":checked")
        // 2. IF (0 Element of "themconcept" level is checked) AND (parent topicheading Element is ":checked")
        if (oneClickLevelTopicheadingElement) {
          if (!parentTopicHeadingElement.checked) {
            if (parentTopicHeadingElement !== false){
              parentTopicHeadingElement.click();
            }
          }
        }
        else if (parentTopicHeadingElement.checked) {
          parentTopicHeadingElement.click();
        }
      } else if ($(this).attr('name') === "themconcept") {
      // Ein-/ausblenden von thematisches concept (click auf themconcept)
      toggleDisplay($(this).attr("value"), "themconcept", isChecked, ".M_TableContent");

      // Verhalten: Wenn auf unterste Ebene "themconcept" Checkbox angehakt wird, 
      // ist die zuhörige Überschrift (Kategorie "topicheading") mittels click auf Unsichtbaren checkbox, ein bzw. auszublenden.
      
      // Identifizierung: zuhörige Übersschrift (parentElement):
      var parentNodeStructure = $(this)[0].parentElement.parentElement.parentElement.parentElement.childNodes;
      var parentTopicHeadingElement = false;
      parentNodeStructure.forEach(function (key, el) {
        if ($(key)[0].nodeName == "SUMMARY") {
          try {
              parentTopicHeadingElement = $(key)[0].children[2];
          }
          catch (e) {
            console.log("Error:" + e);
          }
        }
      });

      // Ist bereits ein Element in der untersten Ebene angehakt (und wurde dadurch bereits die unsichtbare checkbox angehakt) ? 
      // var clickLevelThemconceptElements = $(this)[0].parentElement.parentElement.parentElement.parentElement.parentElement.childNodes[1].childNodes;
      var clickLevelThemconceptElements = $(this)[0].parentElement.parentElement.parentElement.childNodes;
      var oneClickLevelThemconceptElement = false;

      clickLevelThemconceptElements.forEach(function (key, el) {
        if ($(key)[0].nodeName == "DIV") {
          try {
            if ($(key)[0].children[0].children[0].checked) {
              oneClickLevelThemconceptElement = true;
            }
          }
          catch (e) {
            console.log("Error:" + e);
          }
        }
      });

      // 2 Different conditions to click invisible checkbox:
      // 1. IF (any Element of "themconcept" level is checked) AND (parent Element "topicheading" is NOT ":checked")
      // 2. IF (0 Element of "themconcept" level is checked) AND (parent topicheading Element is ":checked")
      if (oneClickLevelThemconceptElement) {
        if (!parentTopicHeadingElement.checked) {
          parentTopicHeadingElement.click();
        }
      }
      else if (parentTopicHeadingElement.checked) {
        parentTopicHeadingElement.click();
      }
    }
  }
  
  $('.M_scrollableOuter:visible').doubleScroll({ resetOnWindowResize: true, onlyIfScroll: false });
  // await fadeOut();
});

$(document).on("change", "#tabcontent-filter input[type=radio]", function (event) {
  event.stopPropagation();
  event.preventDefault();
  if ($(this).attr('value') == 'panel') {
    if ($('#panel')[0].style.display == 'none') {
      $('#cross-sec').toggle();
      $('#panel').toggle();
    }
  } else if ($(this).attr('value') == 'cross-sec') {
    if ($('#cross-sec')[0].style.display == 'none') {
      $('#cross-sec').toggle();
      $('#panel').toggle();
    }
  }
});

/**
  * ON WINDOW RESIZE
  */
$(window).resize(function () {
  adjustHeightOfHeadcol();
});

$(window).bind("load", function () {
  var openSubmenu = $('span[openSubmenu]');
  openSubmenu.parent().accordion("option", "active", 0);
});

/**
  * SCROLL-UP Button
  */

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  $('html, body').animate({ scrollTop: 0 }, 'slow');
}

function scrollFunction(mybutton) {
  try {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      mybutton.style.display = "block";
    } else {
      mybutton.style.display = "none";
    }
  }
  catch (e) {
    console.log(e);
  }
}

/**
  * ONCHANGE-EVENTS
  */

/* Content-Filter */
function resetFilter() {
  if (document.getElementById("selectYear")) {
    if (document.getElementById("selectYear").selectedIndex != null) {
      document.getElementById("selectYear").selectedIndex = 0;
    }
  }
  if (document.getElementById("selectCountry")) {
    if (document.getElementById("selectCountry").selectedIndex != null) {
      document.getElementById("selectCountry").selectedIndex = 0;
    }
  }
  if (document.getElementById("selectLanguage")) {
    if (document.getElementById("selectLanguage").selectedIndex != null) {
      document.getElementById("selectLanguage").selectedIndex = 0;
    }
  }
  $("#selectYear").trigger("change");
}
// Initialize to used in HTML combined with npm webpack:
window.resetFilter = resetFilter;

/**
  * ON PAGE LOAD-EVENTS
  */
window.onload = function () {
  // Got to Top Button:
  var mybutton = document.createElement("BUTTON");   // Create a <button> element
  mybutton.id = "myBtn";
  mybutton.title = "Go to top";
  mybutton.onclick = function () { topFunction() };
  mybutton.innerHTML = "&#x2B06; " + "Top";
  document.body.appendChild(mybutton);               // Append <button> to <body>

  try {
    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function () {
      scrollFunction(mybutton)
    };
  }
  catch (e) {
    //console.log(e);
  }

  // Filter options (Codebooks, Questionnaires, ...)
  $('#FilterOptions').on("change", async function (event) {
    await fadeIn();

    tableContent = $(".docTable > table > tbody");
    studyGroupLabel = $(".gs-intro > h1");
    
    isMZ = studyGroupLabel[0].innerText.search("MZ");
    
    selectedYear = $('#selectYear')[0].value;

    if ($('#selectCountry')[0]) {
      if ($('#selectCountry')[0].value != null) {
        selectedCountry = $('#selectCountry')[0].value;
      }
    }

    if ($('#selectLanguage')[0]) {
      if ($('#selectLanguage')[0].value != null) {
        selectedLanguage = $('#selectLanguage')[0].value;
      }
    }

    var i;
    for (i = 0; i < tableContent[0].childElementCount; i++) {
      TableRowYear = tableContent[0].children[i].children[1].innerText;

      if (isMZ == -1) // Nicht MZ
      {
        TableRowCountry = tableContent[0].children[i].children[2].innerText;
        TableRowLanguage = tableContent[0].children[i].children[3].innerText;
      }

      // Alles 'Spalten' Einblenden:
      tableContent[0].children[i].children[0].style.display = ''; // Title
      tableContent[0].children[i].children[1].style.display = ''; // Year

      if (isMZ == -1) {
        tableContent[0].children[i].children[2].style.display = ''; // Country
        tableContent[0].children[i].children[3].style.display = ''; // Language
      }
      // 'Spalten' Ausblenden Wenn nicht ausgewählt UND nicht leer!
      // Varianen: Year Country Language, O: Visible X: not visible
      //
      // YCL
      // ---
      // XXX
      // OXX
      // OOX
      // XOX
      // XXO 
      // XOO

      if (isMZ == -1) // Nicht MZ
      {
        if ((TableRowYear != selectedYear && selectedYear.length) || (TableRowCountry != selectedCountry && selectedCountry.length) || (TableRowLanguage != selectedLanguage && selectedLanguage.length)) {
          tableContent[0].children[i].children[0].style.display = 'none'; // Title
          tableContent[0].children[i].children[1].style.display = 'none'; // Year
          tableContent[0].children[i].children[2].style.display = 'none'; // Country      
          tableContent[0].children[i].children[3].style.display = 'none'; // Language
        }
      }
      else // MZ
      {
        if ((TableRowYear != selectedYear && selectedYear.length)) {
          tableContent[0].children[i].children[0].style.display = 'none'; // Title
          tableContent[0].children[i].children[1].style.display = 'none'; // Year
          // tableContent[0].children[i].children[2].style.display = 'none'; // Country
        }
      }
    }

    // Zeilenweise Visuelle nachbearbeitung: Nur angezeigte Zeilen nachbearbeiten--> Class: even / odd 
    var xvis;
    var className = "even";

    for (xvis = 0; xvis < tableContent[0].childElementCount; xvis++) {
      if (tableContent[0].children[xvis].children[0].style.display == '') {
        if (className == "even") {
          className = "odd";
          tableContent[0].children[xvis].className = className;
        }
        else {
          className = "even";
          tableContent[0].children[xvis].className = className;
        }
      }
    }

    await fadeOut();
  });
};

document.addEventListener("DOMContentLoaded", function () {
  // Animate loader off screen
  setTimeout(function () {
    $(".se-pre-con").fadeOut("slow");
  }, 200);
});
